import { Paper, Stack, Typography } from '@mui/material';
import { useHVACQuery } from '../decarbonization/queries/hvac';

export const HVAC = () => {
  const { data: hvacs = [] } = useHVACQuery();

  return (
    <Stack spacing={4}>
      {hvacs.map((h) => (
        <Paper key={h.id} elevation={1}>
          <Typography variant={'body1'}>
            {JSON.stringify(h, null, 4)}
          </Typography>
        </Paper>
      ))}
    </Stack>
  );
};
